import PortalIdParser from 'PortalIdParser';
import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import InternalListNameLabel from 'flow-doctor-lib/components/timeline/labels/InternalListNameLabel';
import { isInternalListTimelineItem } from 'flow-doctor-lib/utils/listMembershipTimelineUtils';
import { getListUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const EnvSpecificListNameLabel = ({
  logItem
}) => {
  const objectListMembership = logItem.type === 'LIST_MEMBERSHIP' ? logItem.data : logItem.data.objectListMembership;
  if (logItem.type === 'LIST_MEMBERSHIP_WITH_VISIBILITY' && isInternalListTimelineItem(logItem)) {
    return /*#__PURE__*/_jsx(InternalListNameLabel, {
      logItem: logItem
    });
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.label.external.${objectListMembership.changeStatus}_jsx`,
      elements: {
        ViewLink: UILink,
        b: 'b',
        ListNameLabel
      },
      options: {
        listName: {
          portalId: PortalIdParser.get(),
          listId: objectListMembership.listId,
          showId: getIsInternal()
        },
        listVersion: objectListMembership.listVersion,
        viewLink: {
          external: true,
          href: getListUrl({
            portalId: PortalIdParser.get(),
            listId: objectListMembership.listId
          })
        }
      }
    })
  });
};
export default EnvSpecificListNameLabel;